<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Mesas:"
    id="selectMesa"
    placeholder="Selecione a(s) Mesa(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import MesaRepository from '@/shared/http/repositories/nxSenhas/mesa.js'

export default {
  name: 'NxSelectNxSenhasMesa',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadMesa()
  },
  methods: {
    onLoadMesa () {
      MesaRepository.GetAll()
        .then((response) => {
          let result = response.data.content.map((x) => ({
            value: x.id,
            text: x.nome
          }))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Assuntos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectNxSenhasMesa.vue